export default "__VITE_ASSET__edffcaab__"